(function (angular) {
    'use strict';

    angular.module("dentist").directive('carouselLightboxWrapper', ['$timeout', function($timeout) {
    return {
        link: function($scope, element, attrs) {
            // Trigger when number of children changes,
            // including by directives like ng-repeat
            // optimization: this could also be done with event broadcasting and catching (https://stackoverflow.com/questions/16935766/run-jquery-code-after-angularjs-completes-rendering-html)
            var watch = $scope.$watch(function() {
                return element.children().length;
            }, function() {
                // Wait for templates to render
                $scope.$evalAsync(function() {
                    // Finally, directives are evaluated
                    // and templates are renderer here
//                    var children = element.children();
//                    console.log("l " + element.children().length);
//                    console.log(children);
                    $timeout(function () { // We might need this timeout to be sure its run after DOM render.
                    	initSlickCarousel();
                    	initLightbox();
                    	initLightboxOpener();
                    }, 0, false);
                });
            });
        },
    };
}]);

})(window.angular);
